/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs */

const en_admin_external_booking_edit_no_daily_rates_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No daily rates set up on this resource.`)
};

const de_admin_external_booking_edit_no_daily_rates_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diese Ressource sind keine Tagessätze eingerichtet.`)
};

const es_admin_external_booking_edit_no_daily_rates_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este recurso no tiene tarifas diarias configuradas.`)
};

const fr_admin_external_booking_edit_no_daily_rates_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun tarif journalier n'est configuré pour cette ressource.`)
};

const nl_admin_external_booking_edit_no_daily_rates_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er zijn geen dagtarieven ingesteld voor deze voorziening.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */
const it_admin_external_booking_edit_no_daily_rates_for_resource = en_admin_external_booking_edit_no_daily_rates_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_no_daily_rates_for_resource = en_admin_external_booking_edit_no_daily_rates_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */
const pl_admin_external_booking_edit_no_daily_rates_for_resource = en_admin_external_booking_edit_no_daily_rates_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */
const hu_admin_external_booking_edit_no_daily_rates_for_resource = en_admin_external_booking_edit_no_daily_rates_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs) => LocalizedString} */
const ro_admin_external_booking_edit_no_daily_rates_for_resource = en_admin_external_booking_edit_no_daily_rates_for_resource;

/**
* | output |
* | --- |
* | "No daily rates set up on this resource." |
*
* @param {Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_no_daily_rates_for_resource = /** @type {((inputs?: Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_No_Daily_Rates_For_ResourceInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
	if (locale === "de") return de_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
	if (locale === "es") return es_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
	if (locale === "it") return it_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
	return ro_admin_external_booking_edit_no_daily_rates_for_resource(inputs)
});
export { admin_external_booking_edit_no_daily_rates_for_resource as "admin.external_booking_edit.no_daily_rates_for_resource" }